import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandingConfigurationService } from '@ptl/brand';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';

@Injectable({
  providedIn: 'root'
})
export class DeleteAppService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService
  ) { }

  deleteApplication(applicationTrackingId) {
    const payload = {
      applicationTrackingId
    };

    const requestConfig = new RequestConfigImplementation({
      method: REQUEST_METHODS.POST,
      url: '/sxesvc/api/v3/ext/user/deleteApp',
      POST_OR_PUT_PAYLOAD: payload,
      contentType: 'force_undefined',
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded(),
      }),
      strategyConfigs: { forceModernUrl: true }
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.AXWAY_POST_PASS);
    return this.httpClient.makeRequest(requestConfig);
  }
}
